import { Injectable } from '@angular/core';
import { Time } from './time';

@Injectable({
  providedIn: 'root',
})
export class TimeService {
  public initTimes(maxHour: number): Time[] {
    const times: Time[] = [];
    for (let hour: number = 7; hour <= maxHour; hour++) {
      for (let minute: number = 0; minute < 60; minute++) {
        if (minute % 15 === 0) {
          times.push(new Time(hour, minute));
        }
      }
    }
    return times;
  }

  public getTime(times: Time[], value: Time): Time | undefined {
    const results: Time[] = times.filter((time: Time) => time.hour === value.hour && time.minute === value.minute);
    if (results.length > 0) {
      return results[0];
    }
  }
}
